<div class="content-page">
  <div class="container container-sm">
    <div class="page-header">
      <span class="section-tag">Legal</span>
      <h1 class="page-title">Refund Policy</h1>
      <p class="page-subtitle">Last updated: January 2026</p>
    </div>

    <div class="content-block">
      <h2>30-Day Money-Back Guarantee</h2>
      <p>We offer a full refund on unused credits within 30 days of purchase. If you're not satisfied with our service for any reason, contact our support team and we'll process your refund promptly.</p>
    </div>

    <div class="content-block">
      <h2>Eligibility</h2>
      <p>To be eligible for a refund:</p>
      <ul class="content-list">
        <li>The refund request must be made within 30 days of purchase</li>
        <li>Credits must be unused (or only partially used)</li>
        <li>Account must not have been terminated for terms violations</li>
      </ul>
    </div>

    <div class="content-block">
      <h2>How to Request</h2>
      <p>Email us at <a href="mailto:support@quickindexingtool.com">support&#64;quickindexingtool.com</a> with your account email and order details. We typically process refunds within 3-5 business days.</p>
    </div>

    <div class="content-block">
      <h2>Non-Refundable Items</h2>
      <p>Refunds are not available for:</p>
      <ul class="content-list">
        <li>Credits that have been fully used</li>
        <li>Accounts terminated for violations of our Terms of Service</li>
        <li>Subscriptions (we don't currently offer subscriptions)</li>
      </ul>
    </div>

    <div class="content-block">
      <h2>Disputes</h2>
      <p>If you have a dispute regarding a charge, please contact us first before initiating a chargeback. We're committed to resolving any issues fairly and promptly.</p>
    </div>
  </div>
</div>
